import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { priceShow } from 'shared/lib/priceShow'

import s from './styles.module.scss'

interface Props {
  limit: string
  hasLimit?: boolean
  onShowDetail?: (hasLimit: boolean) => void
}
export const MplusLimit = ({ hasLimit, limit, onShowDetail }: Props) => {
  const { t } = useTranslation()
  return (
    <div className={clsx(s.mplusLimit, !hasLimit && s.exceeded)}>
      <div className={s.text}>
        <p className={clsx(s.description, 'regular-12')}>
          {hasLimit ? t('mplus.available_limit') : t('mplus.limit_exceeded')}
        </p>
        <h4 className={clsx(s.price, 'semi-bold-16')}>{priceShow(limit)}</h4>
      </div>

      <button
        className={clsx(s.button, 'medium-12')}
        onClick={() => onShowDetail?.(!!hasLimit)}
      >
        {hasLimit ? t('mplus.for_what') : t('mplus.how_is_that')}
      </button>
    </div>
  )
}
